module.exports = __webpack_public_path__ + "img/phone.7da00f11.png";